import { Component, input } from '@angular/core';

@Component({
  selector: 'app-nine-sliced-sprite',
  imports: [],
  templateUrl: './nine-sliced-sprite.component.html',
  styleUrl: './nine-sliced-sprite.component.css',
})
export class NineSlicedSpriteComponent {
  src = input.required<string>();
  x = input.required<[number, number]>();
  y = input.required<[number, number]>();
  width = input.required<string>();
}
